import { Config } from 'config';

import { forEach, filter, invokeMap, every } from 'lodash';
import { clone, resolve, and$, or$, not$, filter$, every$, reduce$ } from 'gear';

import { Figure } from './figure';

let conditions      = Figure._condition      = {};
let arrayConditions = Figure._arrayCondition = {};

const composeCondition = function(fo,fn) {
  return function(x) { return fo(x) && fn(x); };
};
const composeCondition$ = function(fo,fn) {
  return function(x) { return and$(fo(x),fn(x)); };
};

const addCondition = function(conditions,name,cond) {
  if( typeof name !== 'string' ) {
    return forEach( name, (c,n) => {
      addCondition(conditions,n,c);
    });
  }

  // Support for alias, like Figure.arrayCondition('groupable', '2+');
  if( typeof cond === 'string' ) {
    if( cond[0] === '!' ) {
     cond = cond.slice(1);
     cond = cond[cond.length-1] === '$' ?() => not$(conditions[cond]) :
                                         () => ! conditions[cond];
    }
    else{
      cond = conditions[cond];
    }
  }

  const cc = conditions[name];
  if( cc ) {
    if( name[name.length-1] === '$' ) {
      conditions[name] = composeCondition$(cc,cond);
    }
    else {
      conditions[name] = composeCondition(cc,cond);
    }
  }
  else {
    conditions[name] = cond;
  }
};

const Figure_condition      = Figure.condition      = function(name,cond) { addCondition(conditions,name,cond); };
const Figure_arrayCondition = Figure.arrayCondition = function(name,cond) { addCondition(arrayConditions,name,cond); };

let restoreConditions      = null;
let restoreArrayConditions = null;

Figure.saveConditions = function() {
  restoreConditions = clone(conditions);
  restoreArrayConditions = clone(arrayConditions);
};
Figure.restoreConditions = function() {
  conditions = clone(restoreConditions);
  arrayConditions = clone(restoreArrayConditions);
};

export const FigureConditions_Mixin = {

  init( config ) {
    this.callParent(...arguments);

    this._conditions      = {};
    this._arrayConditions = {};

    const cc = config.condition;
    if( cc ) {
      this.condition(cc);
    }
    const acc = config.arrayCondition;
    if( acc ) {
      this.arrayCondition(acc);
    }
  },

  condition( name, cond ) {
    addCondition(this._conditions,name,cond);
  },

  arrayCondition( name, cond ) {
    addCondition(this._arrayConditions,name,cond);
  },

  _createCondition( conditions, this_conditions, name ) {
    let tc, fc;
    if( name[0] === '!' ) {
      name = name.slice(1);
      tc = this_conditions[name]; if( tc ) { tc = tc.bind(this); }
      fc = conditions[name];
      return  tc &&  fc ? v => ! fc(v) && ! tc(v)
           :  tc && !fc ? v => ! tc(v)
           : !tc &&  fc ? v => ! fc(v)
                        : null;
    }
    else {
      tc = this_conditions[name]; if( tc ) { tc = tc.bind(this); }
      fc = conditions[name];
      return  tc &&  fc ? v => fc(v) && tc(v)
           :  tc && !fc ? tc
           : !tc &&  fc ? fc
                        : null;
    }
  },
  _createCondition$( conditions, this_conditions, name ) {
    let tc, fc;
    if( name[0] === '!' ) {
      name = name.slice(1);
      tc = this_conditions[name]; if( tc ) { tc = tc.bind(this); }
      fc = conditions[name];
      return  tc &&  fc ? v => not$( or$(fc(v),tc(v)) )
           :  tc && !fc ? v => not$( tc(v) )
           : !tc &&  fc ? v => not$( fc(v) )
                        : null;
    }
    else {
      tc = this_conditions[name]; if( tc ) { tc = tc.bind(this); }
      fc = conditions[name];
      return  tc &&  fc ? v => and$(fc(v),tc(v))
           :  tc && !fc ? tc
           : !tc &&  fc ? fc
                        : null;
    }
  },

  _condition( name ) {
    return this._createCondition(conditions,this._conditions,name);
  },
  _arrayCondition( name ) {
    return this._createCondition(arrayConditions,this._arrayConditions,name);
  },
  _condition$( name ) {
    return this._createCondition$(conditions,this._conditions,name);
  },
  _arrayCondition$( name ) {
    return this._createCondition$(arrayConditions,this._arrayConditions,name);
  },

  is( figure, condition ) {
    if( arguments.length === 2 ) {
      if( typeof condition === 'string' ) {
        return this._condition(condition)(figure);
      }
    }
    else {
      condition = Array.prototype.slice.call(arguments,1);
    }
    return every( condition, c => this.is(figure,c) );
  },

  is$( figure, condition ) {
    if( arguments.length === 2 ) {
      if( typeof condition === 'string' ) {
        if( condition[condition.length-1] === '$' ) {
          return this._condition$(condition)(figure);
        }
        else {
          return resolve(this.is(figure,condition));
        }
      }
    }
    else {
      condition = Array.prototype.slice.call(arguments,1);
    }
    return every$( condition, c => this.is$(figure,c) );
  },

  are( figures, condition ) {
    if( typeof figures === 'string' ) {
      figures = this[figures];
    }

    if( figures.length === 0 ) {
      return false;
    }
    if( arguments.length === 2 ) {
      if( typeof condition === 'string' ) {
        const ac = this._arrayCondition(condition);
        const fc = this._condition(condition);
        // assert( ac || fc, 'Undefined Condition: '+condition );
        if( ac && ! ac(figures) ) {
          return false;
        }
        return fc ? every(figures,fc) : true;
      }
    }
    else {
      condition = Array.prototype.slice.call(arguments,1);
    }
    return every( condition, c => this.are(figures,c) );
  },

  are$( figures, condition ) {
    if( typeof figures === 'string' ) {
      figures = this[figures]();
    }
    if( figures.length === 0 ) {
      return resolve(false);
    }

    if( arguments.length === 2 ) {
      if( typeof condition === 'string' ) {
        if( condition[condition.length-1] === '$' ) {
          const ac = this._arrayCondition$(condition);
          const fc = this._condition$(condition);
          // assert( ac || fc, 'Undefined Condition: '+condition );
          if( ac && fc ) {
            return and$( ac(figures), every$(figures,fc) );
          }
          else if( ac ) {
            return ac(figures);
          }
          else if( fc ) {
            return every$(figures,fc);
          }
          else {
            return resolve(false);
          }
        }
        else {
          return resolve(this.are(figures,condition));
        }
      }
    }
    else {
      condition = Array.prototype.slice.call(arguments,1);
    }
    return every$( condition, c => this.are$(figures,c) );
  },

  only( figures, condition ) {
    if( typeof figures === 'string' ) {
      figures = this[figures];
    }

    if( figures.length === 0 ) {
      return [];
    }
    if( arguments.length === 2 ) {
      if( typeof condition === 'string' ) {
        const ac = this._arrayCondition(condition);
        const fc = this._condition(condition);
        // assert( ac || fc, 'Undefined Condition: '+condition );
        if( ac && ! ac(figures) ) {
          return [];
        }
        return fc ? filter(figures,fc) : true;
      }
    }
    else {
      condition = Array.prototype.slice.call(arguments,1);
    }
    let result = this.only(figures,condition[0]);
    for( let k = 1, kEnd = condition.length; k<kEnd; ++k ) {
      result = this.only(result,condition[k]);
    }
    return result;
  },

  only$( figures, condition ) {
    if( typeof figures === 'string' ) { figures = this[figures](); }
    if( figures.length === 0 ) {
      return resolve([]);
    }

    if( arguments.length === 2 ) {
      if( typeof condition === 'string' ) {
        if( condition[condition.length-1] === '$' ) {
          const ac = this._arrayCondition$(condition);
          const fc = this._condition$(condition);
          // assert( ac || fc, 'Undefined Condition: '+condition );
          if( ac ) {
            return ac(figures) .then( r => r ? ( fc ? filter$(figures,fc) : figures ) : [] );
          }
          else if( fc ) {
            return filter$(figures,fc);
          }
          else {
            return resolve([]);
          }
        }
        else {
          return resolve(this.only(figures,condition));
        }
      }
    }
    else {
      condition = Array.prototype.slice.call(arguments,1);
    }
    return reduce$( condition, (c,fs) => this.only$(fs,c), figures, this);
  },

  saveConditions() {
    this._restoreConditions = clone(this._conditions);
    this._restoreArrayConditions = clone(this._arrayConditions);
  },

  restoreConditions() {
    this._conditions = clone(this._restoreConditions);
    this._arrayConditions = clone(this._restoreArrayConditions);
  }
};

// Modify global figure conditions

const notIsland = function( figure ) {
  return !figure.metadata.get('textureIslandName');
};

Figure_condition('selectable', figure => figure.canBeSelected() || ! notIsland(figure) );

Figure_condition('copyable',      () => true );
Figure_condition('removable',     () => true );
Figure_condition('movable',       () => true );
Figure_condition('scalable',      notIsland );
Figure_condition('rotatable',     () => true );
Figure_condition('skewable',      notIsland );
Figure_condition('groupable',     notIsland );
Figure_condition('ungroupable',   figure => figure.isGroup );
Figure_condition('clipboardable', notIsland );
Figure_condition('textureIsland', figure => !!figure.metadata.get('textureIslandName') );

// [TODO] Needs polishing
Figure_condition('contentEditable', figure => figure.canEditContent() && Config.enableContentEdition );

Figure_condition('aspectRatioChangeable', () => true );

Figure_condition('nodeEditable', figure => figure.isShape &&
                                           figure.processes.length === 0 &&
                                           figure.canBeProcessedLocally() &&
                                           notIsland(figure) );

Figure_arrayCondition('0' , figures => figures.length === 0 );
Figure_arrayCondition('1' , figures => figures.length === 1 );
Figure_arrayCondition('1+', figures => figures.length  >= 1 );
Figure_arrayCondition('2' , figures => figures.length === 2 );
Figure_arrayCondition('2+', figures => figures.length  >= 2 );
Figure_arrayCondition('3' , figures => figures.length === 3 );

Figure_arrayCondition('zorderable', figures => {
  if( figures.length === 0 ) {
    return false;
  }
  const owner = figures[0]._owner;
  return every( invokeMap(figures,'owner'), owner );
});

Figure_arrayCondition('groupable', '2+');

Figure_condition('shape', figure => figure.isShape );

Figure_condition('text', figure => figure.isText );
Figure_condition('simpleText', figure => figure.isText && figure.isSimple );
Figure_condition('typesetText', figure => figure.isText && figure.isTypeset );
Figure_condition('multiPartText', figure => figure.isText && figure.isMultiPart );

Figure_condition('raster', figure => figure.isRaster );
Figure_condition('fullColorRaster', figure => figure.isRaster && !figure.isMonochrome );
Figure_condition('monochromeRaster', figure => figure.isRaster && figure.isMonochrome );

Figure_condition('group', figure => figure.isGroup );

Figure_condition('proxyGroup', figure => figure.isProxyGroup );



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/condition.js
 **/